module.exports = new __parcel__URL__("step-alerts.ab099e16.svg").toString();